module.exports = __webpack_public_path__ + "static/media/add-24px.1eb0d0c6.svg";